import {
  throwMovedAgentNativeModule,
  type DeprecatedExport,
} from "../../package-lifecycle/upgrade-error.js";

throwMovedAgentNativeModule(
  "@agent-native/core/client/components/ui/tooltip",
  "@agent-native/toolkit/ui/tooltip",
);

/** @deprecated @agent-native/core/client/components/ui/tooltip moved to @agent-native/toolkit/ui/tooltip. Run: npx @agent-native/core@latest upgrade --codemods */
export const Tooltip =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/tooltip moved to @agent-native/toolkit/ui/tooltip. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/tooltip moved to @agent-native/toolkit/ui/tooltip. Run: npx @agent-native/core@latest upgrade --codemods */
export const TooltipContent =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/tooltip moved to @agent-native/toolkit/ui/tooltip. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/tooltip moved to @agent-native/toolkit/ui/tooltip. Run: npx @agent-native/core@latest upgrade --codemods */
export const TooltipProvider =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/tooltip moved to @agent-native/toolkit/ui/tooltip. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/tooltip moved to @agent-native/toolkit/ui/tooltip. Run: npx @agent-native/core@latest upgrade --codemods */
export const TooltipTrigger =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/tooltip moved to @agent-native/toolkit/ui/tooltip. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/tooltip moved to @agent-native/toolkit/ui/tooltip. Run: npx @agent-native/core@latest upgrade --codemods */
export const normalizeTooltipText =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/tooltip moved to @agent-native/toolkit/ui/tooltip. Run: npx @agent-native/core@latest upgrade --codemods">;
